export default "__VITE_ASSET__B2clHMsG__";